module.exports = __webpack_public_path__ + "img/ahorcado5.7148aac3.jpg";